

















































// Utils
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Action } from 'vuex-class'
import EventBus from '@/event-bus'
import { buildFilePreview, revokeFilePreview } from '@/utils/documents'
// Services
import Documents from '@/services/Documents'

@Component({
})
export default class ViewFilePartner extends Vue {
  @Prop() fileName!: string
  @Prop() doc!: any
  showModal = false
  previewPDF = false
  file: any = null

  openModalDocuments (document: any) {
    EventBus.$emit('open-modal', document.label ? document : { label: this.fileName, ...document })
  }

  async previewOrDownload (document: any) {
    this.loading(true)
    this.showModal = false
    const [error, response] = await Documents.getDocument({
      entity_type: 'partner',
      identity: document.partner.id,
      document_type: document.type
    })
    this.loading(false)
    if (error) return this.$toasted.global.error(error)
    const preview = buildFilePreview(response)
    this.previewPDF = preview.isPDF
    this.file = preview.url
    this.showModal = true
  }

  @Watch('showModal')
  releasePreview () {
    if (this.showModal) return
    revokeFilePreview(this.file)
    this.file = null
  }

  beforeDestroy () {
    revokeFilePreview(this.file)
  }

  @Action('UPDATE_STATE_LOADING') loading: any
}
